module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.3ec9bb4b.jpg";